import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 45%;\n  height: 45%;\n  border-radius: 50%;\n  border-top: 0;\n  border-left: 0;\n  background-color: ", ";\n  transform: translate(-50%, -50%);\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  font-size: ", ";\n  user-select: none;\n  color: ", ";\n\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n\n      &:hover ", " {\n        border-color: ", ";\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  cursor: pointer;\n\n  &:hover ", " {\n    border-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  background-color: ", ";\n  transition: background-color 180ms;\n\n  ", "\n\n  ", "\n    \n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useCheckbox } from '../checkbox/useCheckbox';
import { Group } from './Group';
import { RadioTag } from './RadioTag';
import { Box } from '../grid/Grid';
var InputWrapper = styled.span(_templateObject());
var Indicator = styled.span(_templateObject2(), themeGet('radio.indicator.size'), themeGet('radio.indicator.size'), themeGet('radio.indicator.border'), themeGet('radio.indicator.borderRadius'), themeGet('radio.indicator.borderColor'), themeGet('radio.indicator.backgroundColor'), function (props) {
  return props.checked && css(_templateObject3(), themeGet('radio.indicator.checked.borderColor'), themeGet('radio.indicator.checked.backgroundColor'));
}, function (props) {
  return props.disabled && css(_templateObject4(), themeGet('radio.indicator.disabled.borderColor'), themeGet('radio.indicator.disabled.backgroundColor'));
}, function (props) {
  return props.checked && props.disabled && css(_templateObject5(), themeGet('radio.indicator.disabledChecked.borderColor'), themeGet('radio.indicator.disabledChecked.backgroundColor'));
});
var Input = styled.input(_templateObject6());
var Wrapper = styled(Box).attrs(function () {
  return {
    as: 'label'
  };
})(_templateObject7(), Indicator, themeGet('radio.indicator.hover.borderColor'), function (props) {
  return props.disabled && css(_templateObject8(), Indicator, props.checked ? themeGet('radio.indicator.disabledChecked.borderColor') : themeGet('radio.indicator.disabled.borderColor'));
});
Wrapper.defaultProps = {
  display: 'inline-flex',
  alignItems: 'center',
  flex: 1
};
var Text = styled.span(_templateObject9(), themeGet('radio.text.fontSize'), themeGet('radio.text.color'), function (props) {
  return props.disabled && css(_templateObject10(), themeGet('radio.text.disabled.color'));
});
var Circle = styled.span(_templateObject11(), themeGet('radio.indicator.icon.backgroundColor'));
export var Radio =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      checked = _ref.checked,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["disabled", "children", "checked", "name", "value", "onChange"]);

  var _useCheckbox = useCheckbox({
    checked: checked,
    onChange: onChange
  }),
      isChecked = _useCheckbox.isChecked,
      handleChange = _useCheckbox.handleChange;

  return (
    /*#__PURE__*/
    React.createElement(Wrapper, _extends({
      checked: isChecked,
      disabled: disabled
    }, rest, {
      ref: ref
    }),
    /*#__PURE__*/
    React.createElement(InputWrapper, null,
    /*#__PURE__*/
    React.createElement(Input, {
      type: "radio",
      name: name,
      value: value,
      checked: isChecked,
      disabled: disabled,
      onChange: handleChange
    }),
    /*#__PURE__*/
    React.createElement(Indicator, {
      checked: isChecked,
      disabled: disabled
    }, isChecked &&
    /*#__PURE__*/
    React.createElement(Circle, null))), children &&
    /*#__PURE__*/
    React.createElement(Text, {
      disabled: disabled
    }, children))
  );
});
Radio.displayName = 'Radio';
Radio.Group = Group;
Radio.Tag = RadioTag;